
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router'

import { useAuth } from '@/context/AuthContext'
import { useSignIn } from '@/hooks/useLeasing'
import { Loading } from '../components/Loading'
import { ErrorPage } from './ErrorPage'

function LeasingLogin() {
  const navigate = useNavigate()
  const { token } = useParams()

  const { isLoading: isAuthLoading } = useAuth()
  const { data: paramsId, mutateAsync, isPending } = useSignIn()
  useEffect(() => {
    if (token)
      mutateAsync({ token })
  }, [token])

  useEffect(() => {
    if (paramsId && !isAuthLoading)
      navigate('/wizard/' + paramsId)
  }, [paramsId, isAuthLoading])

  if (!isPending && !paramsId)
    return <ErrorPage error='Chyba autorizace' />

  return (
    <Loading large={true} />
  )
}

export default LeasingLogin